import { FaceIdProfileUpdate } from '@/features/face-id-profiles';

const FaceIdProfileUpdatePage = () => {
  return <FaceIdProfileUpdate />;
};

export default FaceIdProfileUpdatePage;
